<template>
   <main id="container">
   </main>
</template>

<script>
import { SDK_API } from "@/configs/APIs";
import SdkMixins from "@/mixins/SdkMixins";
import { mapGetters } from "vuex";
import { STATUS_RESPONSES } from "@/configs/SDK";
import HelperMixins from "@/mixins/HelperMixins";

export default {
   name: "RakutenHome",
   components: {},
   mixins: [SdkMixins, HelperMixins],
   data() {
      return {
         event: null,
         rakutenLandingPage: "https://keiba.rakuten.co.jp/?l-id=rakutenlive_pmenu_top"
      };
   },
   computed: {
      ...mapGetters(["isLoggedIn"])
   },
   mounted() {
      this.redirectToRakuten();
   },
   methods: {
      async getEventsByMonth() {
         const {
            data: { data, code }
         } = await this.$http.post(SDK_API.GET_EVENTS_BY_MONTH, { month: new Date().getMonth() + 1, year: new Date().getFullYear() });
         if (code === STATUS_RESPONSES.SUCCESS && data.length > 0) {
            this.event = { ...data[0] };
         }
      },
      async gotoEvent() {
         if (!this.event) return;
         if (!this.isLoggedIn) {
            await this.saveCurrentPageName("WatchStream", {
               slug: this.event.key
            });
            this.$nextTick(() => {
					location.replace(encodeURI(this.getLoginURL))
				});
            return;
         }
         if (!this.event.starting) {
            this.$bvModal.show("popup-event-not-starting");
            return;
         }
         window.location.href = `/stream/${this.event.key}`;
      },
      redirectToRakuten() {
          window.location.href = this.rakutenLandingPage;
      }
   }
};
</script>

<style lang="scss">
#mainimageArea {
   margin-top: 0;
}

.presentLinkArea {
   a {
      text-decoration: underline !important;
   }
}

.presentArea .detail {
   margin-bottom: 0;
   width: 95%;
}

.container {
   padding: 0;
}

.video-overlay {
   position: absolute;
   width: 100%;
   height: 100%;
   top: 0;
   z-index: 10;
   cursor: pointer;
   background: rgba($color: #f7f7f7, $alpha: 0.95);
   div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 100%;
      max-width: 720px;
      margin: 0 auto;

      @include respond(tab-port) {
         max-width: 85%;
      }

      p {
         &:nth-child(1),
         &:nth-child(2) {
            font-weight: bold;
            margin-bottom: 12px;

            @include respond(tab-port) {
               margin-bottom: 8px;
            }
         }
         font-size: 28px;
         line-height: 40px;
         color: #333333;

         @include respond(tab-port) {
            font-size: 90%;
            line-height: 20px;
         }
      }
   }
}

.modal-backdrop {
   background: #4d4d4d !important;
   opacity: 0.4 !important;
   transition: none !important;
}

.modal {
   &__dialog {
      min-width: 530px;
      @include respond(phone) {
         min-width: 90%;
      }
   }
   &__text {
      padding: 30px 40px;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      text-align: center;

      @include respond(phone) {
         padding: 24px 20px;
         font-size: 16px;
      }

      &--2 {
         padding: 0;
         padding-bottom: 30px;

         @include respond(phone) {
            padding-bottom: 24px;
         }
      }
   }
}
</style>
